module.exports = __webpack_public_path__ + "img/pf.e3468aae.svg";